import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-life-home',
  templateUrl: './student-life-home.component.html',
  styleUrls: ['./student-life-home.component.scss']
})
export class StudentLifeHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
